import React from "react";
import buffer from "../assets/portfolio/buffer.png"
import sudoku from "../assets/portfolio/sudoku.png"
import foodApp from '../assets/foodappdash.png'
import blogApp from "../assets/portfolio/blogApp.png";
import frazo from "../assets/portfolio/frazo.jpg";
import lyst from "../assets/portfolio/lyst.png";

import { Fade } from "react-reveal"
import { FaEye,FaGithub} from "react-icons/fa";
const Portfolio = () => {
  const portfolios = [
    {
      id: 1,
      src: foodApp,
      link: "https://city-food-delivery.netlify.app/",
      repo: "https://github.com/harshjoundal/Food_Delivery_app",
      text: "Harvest site clone",
      skills:
        " Mongodb, Nodejs, Express, Mongoose, React, Redux, Javascript, Ant Design, Firebase, Stripe",
      desc: `Full Stack Food Delivery Web App, you can now provide your customers with a seamless and delightful ordering experience from the comfort of their homes.`,
      title: "Food Delivery App",
    },
    {
      id: 2,
      src: buffer,
      link: "https://bufferr.netlify.app/",
      repo: "https://github.com/harshjoundal/BufferClone",
      text: "Buffer site clone",
      skills:
        "React, Redux, React-redux, NPM packages,Javascript, Chakra UI, CSS",
      desc: `This project is clone of Buffer.com   which is digital marketing management site. Here I implemented some functionalities like genetate the graph from data,connect the channels..etc  `,
      title: "Buffer Clone",
    },
    {
      id: 3,
      src: blogApp,
      link: "https://personalblogapp.vercel.app/",
      repo: "https://github.com/harshjoundal/full_stack_blogapp",
      text: "Blog App",
      skills:
        "React,Javascript, Chakra UI, CSS,Redux, ExpressJs, NodeJs, MongoDb",
      desc: "Personal blog app build with MERN stack technology.Have features which allows user to post blogs create account,edit blogs.Has the all the functionalities which full stack app shoud have.",
      title: "Blog App",
    },
    {
      id: 4,
      src: frazo,
      link: "https://frazzokefall.netlify.app/",
      repo: "https://github.com/harshjoundal/cruel-statement-6938",
      text: "Jcrew site clone",
      skills: "ReactJs, JavaScript, MaterialUI, NodeJs, MongoDb, ExpressJs",
      desc: "This is a clone of e-commerce website named as Fraazo. Users can buy groceries on this platform. Generates a random array of items and displays it in deal of the day section. Pages: Home Page, Products Listing Page, Product Details Page, User Detail Page, Cart, Checkout & Payment Page.",
      title: "Fraazo Clone",
    },
    {
      id: 5,
      src: lyst,
      link: "https://lystlyst.netlify.app/",
      repo: "https://github.com/harshjoundal/LYST",
      text: "Mynthresa site clone",
      skills: "Javascript,HTML,CSS",
      desc: "This is LYST website clone.LYST is a fashion technology company, and premium shopping app.This website is build with reactjs,Chakra-UI and mongodb.have features which allow user to create account,login,search products,buy products,payment getway etc...",
      title: "LYST Clone",
    },
    {
      id: 6,
      src: sudoku,
      link: "https://harsh-sudoku.netlify.app/",
      repo: "https://github.com/harshjoundal/Sudoku",
      text: "Mynthresa site clone",
      skills: "React,Javascript,HTML,CSS",
      desc: "Sudoku consists of a 9 × 9 grid with numbers appearing in some of the squares. The object of the puzzle is to fill the remaining squares, using all the numbers 1–9 exactly once in each row, column, and the subgrid of 3 ×  3. ",
      title: "Sudoku",
    },
  ];

  return (
    <div
      name="projects"
      className="bg-gradient-to-b from-black to-gray-800 w-full text-white pb-16 portfolio1 projects "
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Projects
          </p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {portfolios.map(({ id, src, link, repo ,title,desc,skills}) => (
            <div key={id} className="shadow-md shadow-gray-600 rounded-lg duration-200 hover:scale-110">
           <Fade top duration={1000} distance="40px">    <img
                src={src}
                alt="projects"
                className="rounded-md hover:scale-110 duration-500 "
              /> </Fade>
              <div className="p-4">
                <p className="text-center text-xl p-2" >{title}</p>
                <p className="text-sm">{ desc}</p>
                <p className="mt-5 text-sm">Tech Stack : { skills}</p>
              </div>
              <div className="flex m-auto items-center justify-between">
                <button className=" px-6 py-1 m-4 duration-200 text-center   hover:scale-110" onClick={ () => window.open(link, '_blank')}>
                  <FaEye size={30} />
                </button>
                <button className=" px-6 py-1 m-4 text-center duration-200 hover:scale-110 " onClick={ () => window.open(repo, '_blank')}>
                  <FaGithub size={30} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;